import React from 'react';
import { Plus } from 'phosphor-react';
import { SButton } from '@/components/ui/atoms/SButton';

const ButtonTest: React.FC = () => {
  return (
    <div style={{ padding: 24 }}>
      <h2 className="body-sm">SButton Test</h2>

      {/* Row 1: Small + Large */}
      <div style={{ display: 'flex', gap: 48, marginTop: 16 }}>
        {/* Small buttons */}
        <div style={{ width: 120, display: 'flex', flexDirection: 'column', gap: 16 }}>
          <h3 className="body-sm-semibold">Small</h3>
          <SButton
            icon={<Plus />}
            label="Add New"
          />
          <SButton
            size="sm"
            variant="transparent"
            icon={<Plus />}
            label="Add New"
          />
          <SButton
            size="sm"
            variant="outline"
            icon={<Plus />}
            label="Add New"
          />
          <SButton
            size="sm"
            variant="disabled"
            icon={<Plus />}
            label="Add New"
          />
        </div>

        {/* Large buttons (uses body-sm-semibold) */}
        <div style={{ width: 200, display: 'flex', flexDirection: 'column', gap: 16}}>
          <h3 className="body-sm-semibold">Large</h3>
          <SButton
            size="lg"
            variant="primary"
            icon={<Plus />}
            label="Sign In Now"
          />
          <SButton
            size="lg"
            variant="transparent"
            icon={<Plus />}
            label="Sign In Now"
          />
          <SButton
            size="lg"
            variant="outline"
            icon={<Plus />}
            label="Sign In Now"
          />
          <SButton
            size="lg"
            variant="disabled"
            icon={<Plus />}
            label="Sign In Now"
          />
        </div>
      </div>

      {/* Row 2: X-Large buttons (use body-md-semibold) */}
      <div style={{ width: 300, display: 'flex', flexDirection: 'column', gap: 16, marginTop: 32 }}>
        <h3 className="body-md-semibold">X-Large</h3>
        <SButton
          size="xl"
          label="Continue"
        />
        <SButton
          size="xl"
          variant="transparent"
          label="Continue"
        />
        <SButton
          size="xl"
          variant="outline"
          label="Continue"
        />
        <SButton
          size="xl"
          variant="disabled"
          label="Continue"
        />
      </div>
    </div>
  );
};

export default ButtonTest;
